
export default class Party{
	constructor(){
		if(document.body.classList.contains("party-article")){
			this.initPartyArticle();
		}
	}
	initPartyArticle(){
		if(window.currentContext == "pc"){
			const labelbanner = document.querySelector(".wedding-article__labelbanner");
			const main = document.querySelector(".wedding-article__main");
			if(labelbanner && main){
				ScrollTrigger.create({
					trigger: labelbanner,
					start: "top-="+rpx(30)+" top",
					endTrigger: main,
					end: ()=>"bottom+="+(window.innerHeight - labelbanner.offsetHeight - rpx(30))+" bottom",
					pin: true,
					pinSpacing: false
				});
			}
		}
	}
}